// sort-products.pipe.ts
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "sortProducts",
})
export class SortProductsPipe implements PipeTransform {
  transform(products: any[], selectedPartnerId: number | null): any[] {
    if (!products || !selectedPartnerId) return products;

    // Filter the products based on partnerId logic
    const filteredProducts = products
      .filter((product) => {
        const partnerId = product?.partner?.id;
        return (
          Number(partnerId) === selectedPartnerId ||
          Number(partnerId) === 128 ||
          partnerId == null ||
          partnerId != null
        );
      })
      .sort((a, b) => {
        const getPriority = (product: any): number => {
          const partnerId = Number(product?.partner?.id);
          if (partnerId === selectedPartnerId) return 0; // highest priority
          if (partnerId === 128) return 1; // middle
          return 2; // lowest
        };

        return getPriority(a) - getPriority(b);
      });

    // Sort products alphabetically, while keeping partner products at the top
    return filteredProducts.sort((a, b) => {
      // Skip sorting for partner products, as they should stay at the top
      if (
        a?.partner?.id === selectedPartnerId &&
        b?.partner?.id !== selectedPartnerId
      )
        return -1;
      if (
        b?.partner?.id === selectedPartnerId &&
        a?.partner?.id !== selectedPartnerId
      )
        return 1;

      // Compare products based on their first letter (ignoring non-alphabet characters)
      const aName = a?.name ?? "";
      const bName = b?.name ?? "";

      // Function to check if a character is alphabetic
      const isAlpha = (char: string): boolean => /^[A-Za-z]$/.test(char);

      // Get the first character of the product name and check if it's alphabetic
      const firstCharA = aName.trim().charAt(0);
      const firstCharB = bName.trim().charAt(0);

      // If the first character is non-alphabetic, put it at the end
      if (!isAlpha(firstCharA) && isAlpha(firstCharB)) return 1;
      if (isAlpha(firstCharA) && !isAlpha(firstCharB)) return -1;

      // Otherwise, compare the names alphabetically
      return aName.localeCompare(bName);
    });
  }
}
